exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.feedItem[data-v-0eac083b] {\n  padding: 0;\n  height: 240px !important;\n}\n.feedItem .leftSide[data-v-0eac083b] {\n    min-width: 210px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-0eac083b","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/dashboard/FeedcardNewOTA.vue
// module id = 2450
// module chunks = 0